import './news.scss';

export default () => {
	let btn = jQuery( '#loadMore' );
	let blog = '.card-news__item';

	function recall ( btn, blog ) {
		btn.on( 'click', function ( e ) {
			e.preventDefault();
			let nextBtn = $( this );
			let nextPage = nextBtn.attr( 'href' );

			jQuery( '<div id="articles2" style="display: none">' ).load( `${nextPage} ${blog}`, function () {
				jQuery( '#articles' ).append( this );
				const articleNew = document.getElementById( 'articles2' );

				articleNew.replaceWith( ...articleNew.childNodes );

				nextBtn.parent().load( `${nextPage} #loadMore`, function () {
					recall( jQuery( '#loadMore' ), blog );
				} );
			} );
		} );
	}

	recall( btn, blog );
};
